import {useEffect, useState} from 'react'
import {getArchitecture, type Architecture} from '@github-ui/get-os'

export function useArchitecture(): Architecture | undefined {
  const [architecture, setArchitecture] = useState<Architecture | undefined>(undefined)

  useEffect(() => {
    let cancelled = false
    void (async () => {
      const arch = await getArchitecture()
      if (!cancelled && arch) setArchitecture(arch)
    })()
    return () => {
      cancelled = true
    }
  }, [])

  return architecture
}
